import { hot } from 'react-hot-loader/root';
import { isDevelopmentEnvironment } from 'modules/core/settings';

const hotReload = (Root) => {
  return isDevelopmentEnvironment() ? hot(Root) : Root;
};

export default hotReload;
